import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import Link from 'react-router/lib/Link';
import { get } from 'Language';

class SignIn extends Component {

	state = {
		email: '',
		password: ''
	}

    submit = (e) => {
    	e.preventDefault();
    	const { signIn } = this.props;
    	signIn(this.state);
    }

    onChange = (e) => {
    	const { name, value } = e.target;
    	const nextState = {};
    	nextState[name] = value;
    	this.setState(nextState);
    }

    render(){

		return (
			<div className="main-content">
			    <div className="row">

			        <div className="col-md-12 home">
			            <h1>{ get('LOGIN_TITLE') }</h1>
			        </div>
			    </div>
			    <div className="row">
			        <div className="col-md-12">
			            <div className="panel panel-custom">
			                <div className="panel-body">
			                	<form onSubmit={ this.submit }>
				                    <div className="form-group">
				                        <label>{ get('EMAIL') || 'E-mail Address' }</label>
				                        <input
				                        	type="text"
				                        	name="email"
				                        	className="form-control form-custom"
				                        	onChange={this.onChange}/>
				                    </div>
				                    <div className="form-group">
				                        <label>{ get('LOGIN_FORM_PASSWORD') || 'Password' }</label>
				                        <input
				                        	type="password"
				                        	name="password"
				                        	className="form-control form-custom"
				                        	onChange={this.onChange}/>
				                    </div>
				                    <div className="btn-custom">
				                        <button
				                        	type="submit"
				                        	className="btn btn-primary"
				                        	disabled={this.props.isWaiting}>
				                        	{ this.props.isWaiting
				                        		? 'Loading...'
				                        		: get('LOGIN_BUTTON') || 'Login'
				                        	}
				                        </button>
				                        {' '}
				                        <Link to="/forgot"> { get('FORGOT_PASSWORD_LABEL') || 'Forgot Password?'}</Link>
				                    </div>
			                    </form>
			                </div>
			            </div>
			        </div>
			    </div>
			</div>
		)
	}
}

export default connect(
	state => {
		const { isWaiting } = state.onWaiting;

		return {
            isWaiting
		}
	},
	actions
)(SignIn)


// WEBPACK FOOTER //
// ./src/sign-in/containers/SignIn.js